import React from 'react'
import { FaGithub, FaInstagram, FaYoutube, FaTwitter, FaChevronCircleRight } from 'react-icons/fa'
import { Row, Button } from 'react-bootstrap'
import { Link } from "react-scroll";
import './styles.scss'
import { firestore } from '../../firebase/firebase-utils'

function Footer(props) {

    const [subscribed, setSubscribed] = React.useState(false);

    React.useEffect(() => {
        if (props.user) {
            firestore.collection('Subscribers').onSnapshot((query) => {
                query.docs.forEach((doc) => {
                    if (doc.data().Email === props.user.email) {
                        setSubscribed(true)
                    }
                })
            })
            console.log(subscribed)
        }
    }, [props.user,subscribed])

    const handleClick = () => {
        var email = document.getElementById('subscriberInput').value;
        firestore.collection('Subscribers').doc().set({
            Email: email,
            order:Date.now()
        }).then(() => {
            window.alert("User Subscribed")
        })
    }

    return (
        <>
            <Row className="footer">
                <div className="footer-column-div">
                    <div>
                        <h3><u>Quick links</u></h3>
                        <h5><FaChevronCircleRight style={{ color: '#4285f4' }} /><Link style={{ color: '#fff', paddingLeft: '5px' }} smooth={true} duration={300} to="Services">Services</Link></h5>
                        <h5><FaChevronCircleRight style={{ color: '#4285f4' }} /><Link style={{ color: '#fff', paddingLeft: '5px' }} smooth={true} duration={300} to="Our-Work">Projects</Link></h5>
                        <h5><FaChevronCircleRight style={{ color: '#4285f4' }} /><Link style={{ color: '#fff', paddingLeft: '5px' }} smooth={true} duration={300} to="Moto">Motto</Link></h5>
                        <h5><FaChevronCircleRight style={{ color: '#4285f4' }} /><Link style={{ color: '#fff', paddingLeft: '5px' }} smooth={true} duration={300} to="Team">Team members</Link></h5>
                    </div>
                </div>

                <div className="footer-column-div">
                    <div>
                        <h5 style={{ color: '#4285f4' }}>SUBSCRIBE TO NEWSLETTER</h5>
                        <p style={{ color: 'tomato', fontStyle: 'italic' }}>Subscribe to NewsLetter<br /> And get latest News updates directly to your mail.</p>
                        <div className="subscribe">
                            {subscribed === true ? <h4 style={{color:'#fff'}}>SUBSCRIBED !!!</h4> :
                                <>
                                    <input type="email" id="subscriberInput" placeholder="yourname@example.com" validate /> &nbsp;
                                     <Button className="Button" onClick={handleClick}>SUBSCRIBE</Button>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="footer-column-div">
                    <div>
                        <h3><u>Follow us:</u></h3>
                        <h5><FaYoutube /><a href="https://www.youtube.com/channel/UCcw_3Yqn7ip_n20xGv9eFqQ">Youtube</a></h5>
                        <h5><FaGithub /><a href="https://github.com/Techseminal">Github</a></h5>
                        <h5><FaTwitter /><a href="https://twitter.com/techseminal">Twitter</a></h5>
                        <h5><FaInstagram /><a href="https://www.instagram.com/techseminal/">Instagram</a></h5>
                    </div>
                </div>
            </Row>
            <hr style={{ color: 'gray' }} />
            <h6 style={{ color: '#fff', textAlign: 'center', padding: '20px', margin: 0 }}>&copy; 2021 Designed and Developed by <span style={{ color: '#4285f4' }}>TechSeminal</span></h6>
        </>
    )
}

export default Footer